/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FilterContentPinsFromJSON, FilterContentPinsToJSON } from './FilterContentPins';
export function FilterContentFromJSON(json) {
    return FilterContentFromJSONTyped(json, false);
}
export function FilterContentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        pins: !exists(json, 'pins') ? undefined : json['pins'].map(FilterContentPinsFromJSON),
        sizeAll: !exists(json, 'size_all') ? undefined : json['size_all']
    };
}
export function FilterContentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        pins: value.pins === undefined ? undefined : value.pins.map(FilterContentPinsToJSON),
        size_all: value.sizeAll
    };
}
